import {API_URL} from "../config";
import axios from "../utils/axios";
import {ValidateEventFilter} from "./Helpers";

class ParkingEventRepository
{
    getAll(filter) {

        if (!ValidateEventFilter(filter)) {
            return Promise.reject('Date range should be max 1 day in case of other filters are not selected');
        }

        return axios.get(API_URL + "/ParkingEvent/List?", { params: filter });
    }

    export(filter) {
        return axios.get(API_URL + "/ParkingEvent/Export?",
            {
                params: filter,
                responseType: 'blob'
            });
    }

    getById(id) {
        return axios.get(API_URL + `/ParkingEvent/${id}`);
    }
}

export default ParkingEventRepository;
